import { useCard } from '@orbital/games-frontend-library'
import React from 'react'
import { colors } from '../../lib/colors'
import { CardFront } from './CardStyles'
import { handleCardSuit } from './helpers/useCardSuit'
import { CARD_PROPS } from './interface'

export const Card = ({
  background,
  card,
  deal,
  animDelay,
  flipCard,
  showResult,
  noAnimate,
}: CARD_PROPS): JSX.Element => {
  const { handleCardSymbol, handleCardColor } = useCard()

  return (
    <CardFront
      background={background}
      suitColor={handleCardColor(card, colors.cardRed, colors.cardBlack)}
      className='front'
      deal={deal}
      flipCard={flipCard}
      animDelay={animDelay}
      showResult={showResult}
      noAnimate={noAnimate}
    >
      <p>{handleCardSymbol(card)}</p>
      {handleCardSuit(card)}
    </CardFront>
  )
}
